<div class="auth-wrapper auth-cover">
    <div class="auth-inner row m-0">
        <!-- Brand logo-->
        <a class="reg-brand-logo d-flex" routerLink="/">
            <img src="assets/images/logo/logo-full.png" alt="brand-logo" height="28">
            <h2 class="brand-text text-primary ml-1">Alpha Trend</h2>
        </a>
        <!-- /Brand logo-->

        <!-- Left Text-->
        <div class="col-lg-3 d-none d-lg-flex align-items-center p-0">
            <div class="w-100 d-lg-flex align-items-center justify-content-center">
                <img class="img-fluid w-100" src="assets/images/illustration/create-account.svg" alt="multi-steps" />
            </div>
        </div>
        <!-- /Left Text-->

        <!-- Register-->
        <div class="col-lg-9 d-flex align-items-center auth-bg px-2 px-sm-3 px-lg-5 pt-3">
            <div class="mx-auto">
                <div id="account-details" class="content mt-3 mt-lg-0" role="tabpanel" aria-labelledby="account-details-trigger">
                    <form [formGroup]="accountForm" (ngSubmit)="onAccountSubmit()">
                        <div class="content-header mb-2">
                            <h2 class="fw-bolder mb-75">Choose a service</h2>
                        </div>
                        <!-- select plan options -->
                        <div class="row custom-options-checkable my-2 gx-3 gy-2">
                            <div class="col-md-6">
                                <input class="custom-option-item-check" formControlName="product" type="radio" name="product" id="basicPlan" value="SIX_MONTH_PACK" />
                                <label class="custom-option-item text-center p-1" for="basicPlan">
                                    <span class="custom-option-item-title h3 fw-bolder">6 Month Pack</span>
                                    <!-- <span class="d-block m-75">A simple start for everyone</span> -->
                                    <span class="plan-price">
                                        <sup class="font-medium-1 font-weight-bold text-primary">$ </sup>
                                        <span class="pricing-basic-value font-weight-bolder text-primary">{{servicesPrice?.SIX_MONTH_PACK}}</span>
                                        <!-- <sub class="pricing-duration text-body font-medium-1 font-weight-bold">/every 6 month</sub> -->
                                    </span>
                                </label>
                            </div>

                            <div class="col-md-6">
                                <input class="custom-option-item-check" formControlName="product" type="radio" name="product" id="standardPlan" value="YEARLY_PACK" />
                                <label class="custom-option-item text-center p-1" for="standardPlan">
                                    <span class="custom-option-item-title h3 fw-bolder">Yearly Pack</span>
                                    <!-- <span class="d-block m-75">For small to medium businesses</span> -->
                                    <span class="plan-price">
                                        <sup class="font-medium-1 font-weight-bold text-primary">$ </sup>
                                        <span class="pricing-basic-value font-weight-bolder text-primary">{{servicesPrice?.YEARLY_PACK}}</span>
                                        <sub class="pricing-duration text-body font-medium-1 font-weight-bold text-decoration-line-through">/$600</sub>
                                    </span>
                                </label>
                            </div>

                            <!-- <div class="col-md-4">
                                <input class="custom-option-item-check" formControlName="product" type="radio" name="product" id="nftPlan" value="ENTERPRISE_PACK" />
                                <label class="custom-option-item text-center p-1" for="nftPlan">
                                    <span class="custom-option-item-title h3 fw-bolder">Enterprise Pack</span>
                                    <span class="plan-price">
                                        <a href="mailto:hello@alphatrend.ai" class="font-medium-5 font-medium-1 font-weight-bolder">Contact Us</a>
                                    </span>
                                </label>
                            </div> -->
                        </div>
                        <div *ngIf="submitted && af.product.errors" class="invalid-feedback mb-1"
                            [ngClass]="{ 'd-block': submitted && af.product.errors }">
                            <div *ngIf="af.product.errors.required">Please Choose a service.</div>
                        </div>

                        <div class="content-header my-2">
                            <h2 class="fw-bolder mb-75">Account Information</h2>
                        </div>

                        <!-- / select plan options -->
                        <div class="row">
                            <div class="col-md-6 mb-1">
                                <div class="form-group">
                                    <label for="register-email" class="form-label">Email</label>
                                    <input id="register-email"
                                      type="text"
                                      formControlName="email"
                                      class="form-control"
                                      placeholder="john@example.com"
                                      aria-describedby="register-email"
                                      tabindex="1"
                                      autofocus
                                      [ngClass]="{ 'is-invalid': submitted && af.email.errors }"
                                    />
                                    <div *ngIf="submitted && af.email.errors" class="invalid-feedback">
                                      <div *ngIf="af.email.errors.required">Email is required</div>
                                      <small *ngIf="af.email.errors?.pattern" class="text-danger">Email must be a valid email address</small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-1">
                                <div class="form-group">
                                    <label for="register-password" class="form-label">Password</label>
                                    <div class="input-group input-group-merge form-password-toggle">
                                      <input id="register-password"
                                        [type]="passwordTextType ? 'text' : 'password'"
                                        formControlName="password"
                                        class="form-control form-control-merge"
                                        placeholder="············"
                                        aria-describedby="register-password"
                                        tabindex="2"
                                        [ngClass]="{ 'is-invalid error': submitted && af.password.errors }"
                                      />
                                      <div class="input-group-append">
                                        <span class="input-group-text cursor-pointer"
                                          ><i
                                            class="feather font-small-4"
                                            [ngClass]="{
                                              'icon-eye-off': passwordTextType,
                                              'icon-eye': !passwordTextType
                                            }"
                                            (click)="togglePasswordTextType()"
                                          ></i
                                        ></span>
                                      </div>
                                    </div>
                                    <div
                                      *ngIf="submitted && af.password.errors"
                                      class="invalid-feedback"
                                      [ngClass]="{ 'd-block': submitted && af.password.errors }"
                                    >
                                      <div *ngIf="af.password.errors.required">Password is required</div>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-1">
                                <div class="form-group">
                                    <label for="register-username" class="form-label">Full name</label>
                                    <input id="register-username"
                                      type="text"
                                      formControlName="fullName"
                                      class="form-control"
                                      placeholder="Enter full name"
                                      aria-describedby="register-fullName"
                                      tabindex="3"
                                      [ngClass]="{ 'is-invalid': submitted && af.fullName.errors }"
                                    />
                                    <div *ngIf="submitted && af.fullName.errors" class="invalid-feedback">
                                      <div *ngIf="af.fullName.errors.required">Full name is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-1">
                                <div class="form-group">
                                    <label for="register-hearAboutUs" class="form-label">How did you hear about us?</label>
                                    <select id="register-hearAboutUs" tabindex="4" [ngClass]="{ 'is-invalid': submitted && af.hearAboutUs.errors }" formControlName="hearAboutUs" class="form-control">
                                      <option value="Twitter">Twitter</option>
                                      <option value="Reddit">Reddit</option>
                                      <option value="Facebook">Facebook</option>
                                      <option value="Friends">Friends</option>
                                      <option value="Email from Alpha Trend">Email from Alpha Trend</option>
                                      <option value="LinkedIn">LinkedIn</option>
                                      <option value="LinkedIn">Google search</option>
                                    </select>
                                    <div *ngIf="submitted && af.hearAboutUs.errors" class="invalid-feedback">
                                      <div *ngIf="af.hearAboutUs.errors.required">Field is required</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-1">
                                <div class="form-group">
                                    <label for="defaultProduct" class="form-label">What is your preferred trading?</label>
                                    <select id="defaultProduct" tabindex="5" [ngClass]="{ 'is-invalid': submitted && af.defaultProduct.errors }" formControlName="defaultProduct" class="form-control">
                                      <option [value]="'STOCK'">STOCK</option>
                                      <option [value]="'CRYPTO'">CRYPTO</option>
                                      <!-- <option [value]="'NFT'">NFT</option> -->
                                    </select>
                                    <div *ngIf="submitted && af.defaultProduct.errors" class="invalid-feedback">
                                      <div *ngIf="af.defaultProduct.errors.required">Field is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-1">
                                <div class="form-group">
                                    <label for="referal" class="form-label">Referral Code</label>
                                    <input id="referal"
                                    tabindex="6"
                                    type="text"
                                    formControlName="referalCode"
                                    class="form-control"
                                    placeholder="Code"
                                    aria-describedby="referal"
                                    />
                                    <div *ngIf="codeError" class="invalid-feedback d-block">
                                        <div>Invalid Code</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-1">
                                <div class="form-group">
                                    <label for="walletaddress" class="form-label">Wallet Address</label>
                                    <input tabindex="7" id="walletaddress" type="text" formControlName="walletAddress" class="form-control" aria-describedby="walletAddress"
                                    />
                                </div>
                            </div>
                        </div>

                        <ng-container *ngIf="discount <=99">

                            <div class="content-header mb-2 py-1">
                                <h2 class="fw-bolder mb-75">Payment Information</h2>
                                <span>Enter your card Information</span>
                            </div>

                            <div class="row gx-2">
                                <div class="col-12 mb-1">
                                    <label class="form-label" for="addCardNumber">Card Number</label>
                                    <input id="addCardNumber" [tabindex]="af.product.value == 'STOCK_CRYPTO_NFT' ? '8' : '7'" [ngClass]="{ 'is-invalid': submitted && af.number.errors }" formControlName="number" name="addCard" class="form-control credit-card-mask" type="text" placeholder="1356 3215 6548 7898" mask="0000 0000 0000 0000 || 0000 000000 00000" aria-describedby="addCard" data-msg="Please enter your credit card number" />
                                    <div *ngIf="submitted && af.number.errors" class="invalid-feedback">
                                        <div *ngIf="af.number.errors.required">Field is required</div>
                                    </div>
                                </div>

                                <div class="col-6 col-md-4 mb-1">
                                    <label class="form-label">Month</label>
                                    <input type="text" formControlName="expMonth" [tabindex]="af.product.value == 'STOCK_CRYPTO_NFT' ? '9' : '8'" [ngClass]="{ 'is-invalid': submitted && af.expMonth.errors }" class="form-control expiry-date-mask" placeholder="MM" mask='00' />
                                    <div *ngIf="submitted && af.expMonth.errors" class="invalid-feedback">
                                        <div *ngIf="af.expMonth.errors.required">Field is required</div>
                                    </div>
                                </div>

                                <div class="col-6 col-md-4 mb-1">
                                    <label class="form-label">Year</label>
                                    <input type="text" formControlName="expYear" [tabindex]="af.product.value == 'STOCK_CRYPTO_NFT' ? '10' : '9'" [ngClass]="{ 'is-invalid': submitted && af.expYear.errors }" class="form-control expiry-date-mask" placeholder="YYYY" mask='0000' />
                                    <div *ngIf="submitted && af.expYear.errors" class="invalid-feedback">
                                        <div *ngIf="af.expYear.errors.required">Field is required</div>
                                    </div>
                                </div>

                                <div class="col-6 col-md-4 mb-1">
                                    <label class="form-label">CVV</label>
                                    <input type="text" formControlName="cvc" [tabindex]="af.product.value == 'STOCK_CRYPTO_NFT' ? '11' : '10'" [ngClass]="{ 'is-invalid': submitted && af.cvc.errors }" class="form-control cvv-code-mask" maxlength="4" placeholder="****" />
                                    <div *ngIf="submitted && af.cvc.errors" class="invalid-feedback">
                                        <div *ngIf="af.cvc.errors.required">Field is required</div>
                                    </div>
                                </div>
                            </div>

                        </ng-container>

                        <div class="row">
                            <div class="col-12 mb-1">
                                <div class="form-group">
                                    <div class="custom-control custom-checkbox">
                                      <input class="custom-control-input" type="checkbox" id="register-isNewsletter" formControlName="isNewsletter" [tabindex]="af.product.value == 'STOCK_CRYPTO_NFT' ? '12' : '11'" />
                                      <label class="custom-control-label" for="register-isNewsletter">Do you wish to receive newsletters?</label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mb-1">
                                <div class="form-group">
                                    <div class="custom-control custom-checkbox">
                                      <input class="custom-control-input" [tabindex]="af.product.value == 'STOCK_CRYPTO_NFT' ? '13' : '12'" type="checkbox" id="privacy" tabindex="9" [formControl]="isAcceptPrivacyPolicy" />
                                      <label class="custom-control-label" for="privacy">
                                        Please click <a href="javascript:void(0);" (click)="openPrivacyModal(policy)">here</a> to read and agree to our terms and condition.
                                      </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div *ngIf="errorMessage">
                        <ngb-alert class="p-1" [dismissible]="true" [type]="'danger'">{{ errorMessage }}</ngb-alert>
                    </div>

                    <div class="d-flex flex-lg-row flex-column justify-content-between my-2">
                        <div>
                            <p class="text-center"><span>Already have an account?</span><a (click)="gotoLogin()" class="text-primary"><span>&nbsp;Sign in instead</span></a></p>
                        </div>
                        <button class="btn btn-success btn-next" (click)="onAccountSubmit()" [disabled]="!isAcceptPrivacyPolicy?.value">
                            <ng-container *ngIf="!isLoading">
                                <span class="align-middle d-sm-inline-block">Subscribe</span>
                            </ng-container>
                            <ng-container *ngIf="isLoading">
                                <div class="spinner-border spinner-border-sm" role="status"></div>
                            </ng-container>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Register-->
    </div>
</div>

<ng-template #policy let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Disclaimer</h4>
    </div>
    <div class="modal-height modal-body">
        <p ngbAutofocus>This is not an offer, solicitation of an offer or advice to buy or sell securities, or open a brokerage account in any jurisdiction where Alpha Trend, Inc is not registered.</p>
        <p>Alpha Trend, Inc does not recommend any securities. All investments involve risk and the past performance of a security or financial product does not guarantee future results or returns. Keep in mind that while diversification may help spread risk it does not assure a profit, or protect against loss, in a down market. There is always the potential of losing money when you invest in securities or other financial products. Investors should consider their investment objectives and risks carefully before investing.</p>
        <p>The above content is provided for general informational purposes only. It is not intended to constitute investment advice or any other kind of professional advice and should not be relied upon as such. Before taking action based on any such information, we encourage you to consult with the appropriate professionals. We do not endorse any third parties referenced within the article. Market and economic views are subject to change without notice and may be untimely when presented here. Do not infer or assume that any securities, sectors or markets described in this article were or will be profitable. Past performance is no guarantee of future results. There is a possibility of loss. Historical or hypothetical performance results are presented for illustrative purposes only.</p>
        <p>Investors should be aware that system response, execution price, speed, liquidity, market data, and account access times are affected by many factors, including market volatility, size and type of order, market conditions, system performance, and other factors. These risks are to be assumed by the customer. For additional information on data provided within the App, please see our Data Disclosure.</p>
        <p>Third-party information provided for Alpha Trend, Inc product features, Alpha Trend, Inc communications and communications emanating from its social media community, market prices, data and other information available through Alpha Trend, Inc are meant for informational purposes only and are not intended as an offer or solicitation for the purchase or sale of any financial instrument or as an official confirmation of any transaction. The information provided is not warranted as to completeness or accuracy and is subject to change without notice. The Alpha Trend, Inc website provides its users' links to social media sites and email. The linked social media and email messages are pre-populated. However, these messages can be deleted or edited by Alpha Trend, Inc users, who are under no obligation to send any pre-populated messages. Any comments or statements made herein do not reflect the views of Alpha Trend, Inc or any of its subsidiaries or affiliates. Note that certain Alpha Trend, Inc product features listed are currently in development and will be available soon. Alpha Trend, Inc., may receive payment for order flow through third parties.</p>
        <p>Alpha Trend, Inc is not a registered broker-dealer or FINRA member. Crypto trading involves substantial risk of loss and there can be significant volatility in the price of cryptocurrencies. Cryptocurrency trading is not suitable for all investors and each investor should evaluate their own particular financial circumstances to determine whether trading cryptocurrencies is appropriate for them. Crypto trading is not yet available for New York state residents. Please ensure that you fully understand the risks involved before trading.</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="acceptPolicy(false)">Cancel</button>
        <button type="button" class="btn btn-success" (click)="acceptPolicy(true)">I Agree</button>
    </div>
</ng-template>
